import React from "react";
import logo from "../../Media/logo2.webp";
import logo3 from "../../Media/logo3.webp";
import inn from "../../Media/in.webp";
import you from "../../Media/you.webp";

const Footer = () => {
  return (
    <footer class="py-4 bg-black shadow md:px-6 md:py-8 font-sansSerif">
        <div className="w-11/12 mx-auto">
        <div class="sm:flex  sm:justify-between">
        <div>
          <a
            href="https://flowbite.com/"
            class="flex items-center mb-4 sm:mb-0"
          >
            <img src={logo} class="mr-3 h-8" alt="Flowbite Logo" />
          </a>
          <p className="text-white text-xl md:w-7/12 mt-5">
            We work on an outcome based and fixed price model.
          </p>
        </div>
        <div className="text-white">
          <h3 className="text-3xl font-bold mb-5">Solutions</h3>
          <p className="text-xl mb-5">Blogs</p>
          <p className="text-xl mb-5">Request a POC</p>
        </div>
        <div className="text-white">
          <h3 className="text-3xl font-bold mb-5">Solutions</h3>
          <p className="text-xl flex mb-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
              />
            </svg>
            <p className="ml-5">+441908103333</p>
          </p>
          <p className="text-xl flex mb-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
              />
            </svg>
            <p className="ml-5">info@qualyval.com</p>
          </p>
          <p className="text-xl flex mb-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
              />
            </svg>
            <p className="ml-5">Milton Keyens, United Kingdom</p>
          </p>
        </div>
      </div>
      <div className="sm:flex justify-between mt-32">
        <img src={logo3} alt="" />
        <div className="flex">
          <img className="w-[29px] h-[29px] mr-2" src={inn} alt="" />
          <img className="w-[33px] h-[33px]" src={you} alt="" />
        </div>
      </div>
        </div>
    </footer>
  );
};

export default Footer;
